import React from 'react';
import PropTypes from 'prop-types';

const ThreadStatus = ({ status, isRead }) => {
  const statusStyleMap = {
    expired: 'text-green-400 bg-green-200',
    pending: 'text-orange-400 bg-orange-150',
    'cancelled by client': 'text-red-600 bg-red-200',
    accepted: 'text-green-400 bg-green-200',
    'declined by space': 'text-red-600 bg-red-200',
    'proposal sent': 'text-green-400 bg-green-200',
    'cancelled by space': 'text-red-600 bg-red-200',
    'pending payment': 'text-orange-400 bg-orange-150',
    paid: 'text-green-400 bg-green-200',
    'pending bank deposit': 'text-orange-400 bg-orange-150',
  }
  return (
    <div className="flex items-center">
      {!isRead && <div className="w-2 h-2 bg-red-700 rounded-full mr-2" />}
      <span
        className={`font-semibold text-xs px-4 py-1 ${statusStyleMap[status]} rounded`}>
        {status && status.toUpperCase()}
      </span>
    </div>
  );
}

ThreadStatus.propTypes = {
  status: PropTypes.string,
  isRead: PropTypes.bool
};

export default ThreadStatus;
